import React, { ReactElement } from 'react';
import { getCdnImageUrl } from 'b2b-apps/shop/routes/utils/url';
import { ComponentType, Props } from './';
import './DangerIcons.scss';

const DangerIcons: ComponentType = ({ dangerIcons }: Props): ReactElement => (
  <div className="ProductDescription-DangerIconGroup">
    {dangerIcons.map((icon, key) => (
      <div key={key} className="ProductDescription-DangerIcon">
        <img src={getCdnImageUrl(icon.link) || ''} alt={icon.name} />
      </div>
    ))}
  </div>
);

export { DangerIcons };
